
export default function Started (){
   
   
    return (
        <div className="container--big-row">
        <div className="started--container ">
            <div className="content--description">
            <h1 className="started-title">Welcome to Meow Hosting: <span className="special-color">Your Ultimate Hosting Solution</span></h1> 
            <p className="started-para">Join the Meow Hosting clowder by completing our quick and secure sign-up process. Choose your ideal hosting plan, select a domain name, and provide your information to get started. With just a few clicks, you'll have access to your hosting account, ready to install and launch your website, backed by our reliable support every step of the way.</p>  
            <div className="input-container">
            <div className="input-container--mobile">
            <input type="text" placeholder="Your E-mail Address"/>
            </div>
            <button className="btn no-cursor">Get Started</button>
            </div>
            <div>
                <span className="customers-text">OUR TRUSTED CUSTOMERS</span>
                <div className="started--customers-container">
                <i class="fa-solid fa-cat customer-icon"></i>
                <i class="fa-solid fa-shield-cat customer-icon"></i>
                <i class="fa-solid fa-paw customer-icon"></i>
                <i class="fa-solid fa-dog customer-icon"></i>
                
                
                
               </div>
            </div>
            
            </div>
          
            <figure className="content--img-container"><img src='cats-on-latopbetter.png' alt="Meow Hosting Welcome"/></figure></div>
         
        </div>
        
        )
}